var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radio"},_vm._l((_vm.radioData),function(data,index){return _c('div',{staticClass:"sdnm-radio",on:{"click":function($event){return _vm.change(index)}}},[_c('i',{class:{
        'sdnm-circular_selected': data.id === _vm.radioCheckedId,
        'sdnm-circular_not_selected': data.id !== _vm.radioCheckedId,
      }}),_c('span',[_vm._v(_vm._s(data.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }